import { useMatchRoute } from "@tanstack/react-router";

// Statically imported by the nav and the chat shell, so it must not pull in the chat's own dependencies.

/** Whether a takeover is on screen: the onboarding landing or a shift or job canvas. */
export const useOnTakeover = () => {
  const matchRoute = useMatchRoute();
  return (
    !!matchRoute({ to: "/locations/$locationId/get-started" }) ||
    !!matchRoute({ to: "/locations/$locationId/post/shift" }) ||
    !!matchRoute({ to: "/locations/$locationId/post/job" })
  );
};
